import { gql } from '@apollo/client';

const Fragments = {
  engineScoringGrid: gql`
    fragment engineScoringGrid on EngineScoringGrid {
      engineScoringId
      name
      code
      version
      active
      validFrom
      validTo
    }
  `
};

export default Fragments;
